import { LogoutOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

import { useSessionStore } from '@/store/useSessionStore';

const SessionInvalidatedModal = () => {
  const { isSessionInvalidatedModalOpen, setSessionInvalidatedModalOpen } = useSessionStore();

  const handleOk = () => {
    setSessionInvalidatedModalOpen(false);
    globalThis.location.href = '/login';
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2 text-red-600">
          <LogoutOutlined />
          <span>Oturum Sonlandırıldı</span>
        </div>
      }
      open={isSessionInvalidatedModalOpen}
      onOk={handleOk}
      onCancel={handleOk}
      okText="Tamam"
      cancelButtonProps={{ style: { display: 'none' } }}
      closable={false}
      maskClosable={false}
      zIndex={9999}
    >
      <p className="text-base">Başka bir cihazdan giriş yapıldığı için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapın.</p>
    </Modal>
  );
};

export default SessionInvalidatedModal;
